module.exports = __webpack_public_path__ + "static/media/mainimg-06.d43cf920.png";